import { useGtm } from '@gtm-support/vue-gtm'

const click = (event: string, body: any): void => {
	const $gtm = useGtm()

	$gtm?.trackEvent({
		action: 'click',
		event,
		...body,
	})
}
const getPagePath = () => {
	return window.location.href
}
const getTimeStamp = () => {
	const now = new Date()
	const tzo = -now.getTimezoneOffset()
	const dif = tzo >= 0 ? '+' : '-'
	const pad = (num: number) => {
		const norm = Math.abs(Math.floor(num))
		return (norm < 10 ? '0' : '') + norm
	}
	return (
		now.getFullYear() +
		'-' +
		pad(now.getMonth() + 1) +
		'-' +
		pad(now.getDate()) +
		'T' +
		pad(now.getHours()) +
		':' +
		pad(now.getMinutes()) +
		':' +
		pad(now.getSeconds()) +
		'.' +
		pad(now.getMilliseconds()) +
		dif +
		pad(tzo / 60) +
		':' +
		pad(tzo % 60)
	)
}

/**
 * Thin wrapper around Google Tag Manager for firing LuckyWise analytics events.
 * - `click(event, body)` — pushes a GTM `click` event with arbitrary payload.
 * - `getTimeStamp()` — returns the current local time as an ISO-8601 string with timezone offset.
 * - `getPagePath()` — returns `window.location.href`.
 */
export const LuckyWiseAnalytics = {
	click,
	getTimeStamp,
	getPagePath,
}
